<script setup>
import { BLink } from 'bootstrap-vue-next';

import OrangeBannerBackgroundSvg from '@images/orange-banner-background.svg';

import { toLocaleDateStringIgnoringTimezone } from '~/common/DateUtils';

const props = defineProps({
  hackathon: {
    type: Object,
    required: true,
  },
});

const endDateLabel = toLocaleDateStringIgnoringTimezone(new Date(props.hackathon.to_date));
</script>

<template>
  <div class="orange-gradient-banner">
    <img
      :src="OrangeBannerBackgroundSvg"
      alt=""
      class="orange-gradient-banner__bg"
    >
    <p class="orange-gradient-banner__text">
      The <strong>{{ hackathon.display_name }} Hackathon</strong>
      is live! Contribute by {{ endDateLabel }}.
    </p>
    <BLink
      :to="{ name: 'hackathon' }"
      class="orange-gradient-banner__cta"
    >
      View hackathon
    </BLink>
  </div>
</template>
